import script from "./AdminLocationPolicies.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminLocationPolicies.vue?vue&type=script&setup=true&lang=ts"

import "./AdminLocationPolicies.vue?vue&type=style&index=0&id=29bdf6b4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-29bdf6b4"]])

export default __exports__